export const GEOCODE_MAPS_API_KEY = "de4336df-a15a-4676-973a-9f9704a66288";
export const SUGGEST_MAPS_API_KEY = "673dcf99-77bf-4cc8-9fad-59500ec1e4ca";

export const NEXT_PUBLIC_API_INTERNAL_BASE_URL = process.env.NODE_ENV === "production" ? "https://goar70.ru/api/v1" : "https://dev.goar70.ru/api/v1";
export const NEXT_PUBLIC_API_BASE_URL = process.env.NODE_ENV === "production" ? "https://goar70.ru/api/v1" : "https://dev.goar70.ru/api/v1";

export const ROBOKASSA_IS_TEST = true;
export const ROBOKASSA_PASSWORD_1 = ROBOKASSA_IS_TEST ? "vsQ97uFKq6FR55BfXUqJ" : "nXpzE1pS5ZaBe4Phsv56";
export const ROBOKASSSA_MERCHANT_LOGIN = "Goar2"

export const MOCKED_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjowLCJyb2xlIjoidXNlciIsImV4cCI6MjA3MzI5NzYwMCwiaWF0IjoxMjU3ODk0MDAwfQ.xhYd2Jx7mlNElZ35c6s33Cawo7JFnlIB-bMSqdzBd4M"
export const TELEGRAM_AUTH_BOT_URL = process.env.NODE_ENV === "production" ? 'https://t.me/goar_auth_bot' : 'https://t.me/goar_auth_deb_bot';

export const ONESIGNAL_ID = "1329ec5d-49a1-4292-8bc1-31b72bd59fc1";
export const ONESIGNAL_REST_API_KEY = "os_v2_app_cmu6yxkjufbjfc6bgg3sxvm7yhtnmf6vqfze46mkmhtzwx2w2qutlocilb2gucxzl5sfnkytov2inxwiedpiyaclnbsrkdyevmbkcui";
